// extracted by mini-css-extract-plugin
export default {"inputHolder":"InputToken_inputHolder__-pDVg","inputToken":"InputToken_inputToken__EA8M-","inputLabel":"InputToken_inputLabel__ic5Mi"};